export const MESSENGER_IDS = ["telegram", "max"];

export const MESSENGERS = {
  telegram: {
    id: "telegram",
    label: "Telegram",
    shareHint: "Сотрудники открывают ссылку в Telegram-боте",
    pasteHint: "https://t.me/…?start=ID_сценария",
    botName: () =>
      (process.env.REACT_APP_BOT_NAME || "MoGame_bot").replace(/^@/, ""),
  },
  max: {
    id: "max",
    label: "MAX",
    shareHint: "Сотрудники открывают ссылку в боте MAX",
    pasteHint: "https://max.ru/…?start=ID_сценария",
    botName: () =>
      (process.env.REACT_APP_MAX_BOT_NAME || "MoGame_bot").replace(/^@/, ""),
  },
};

export function isMessengerId(value) {
  return MESSENGER_IDS.includes(value);
}

export function getMessengerMeta(messengerId) {
  return MESSENGERS[isMessengerId(messengerId) ? messengerId : "telegram"];
}

export function resolveMessenger({ userMessenger, gameMessenger } = {}) {
  if (isMessengerId(gameMessenger)) return gameMessenger;
  if (isMessengerId(userMessenger)) return userMessenger;
  return "telegram";
}

export function getGroupShareLink(gameId, messengerId = "telegram") {
  const meta = getMessengerMeta(messengerId);
  const botName = meta.botName();
  if (!gameId || !botName) return "";

  if (messengerId === "max") {
    return `https://max.ru/${botName}?start=${gameId}`;
  }

  return `https://t.me/${botName}?start=${gameId}`;
}

export function getAccessModeHint(messengerId = "telegram") {
  const label = getMessengerMeta(messengerId).label;
  return `Сотрудники проходят сценарий по общей ссылке в ${label}. Нужна активная бизнес-подписка по размеру команды.`;
}

export function getMessengerChannelLabel(messengerId = "telegram") {
  return getMessengerMeta(messengerId).label;
}
